export function getAge(birthdate) {
    const today = new Date();
    const birthDate = new Date(birthdate);
    const age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        return age - 1;
    }
    return age;
}
export function getHabits(habits) {
    if (habits) {
        let habits_string = "";
        let habit_list = [];
        if (habits.smoking_status) {
            if (habits.smoking_status.id !== 1) {
                habit_list.push("Tabáquico");
            }
        }
        if (habits.alcohol) {
            habit_list.push("Consumo de Alcohol");
        }
        if (habits.drugs) {
            habit_list.push("Drogas");
        }
        habits_string = habit_list.join(", ");
        let lastChar = habits_string.lastIndexOf(",");
        if (lastChar !== -1) {
            habits_string =
                habits_string.slice(0, lastChar) +
                    " y" +
                    habits_string.slice(lastChar + 1);
        }
        return habits_string;
    }
    else {
        return "No tiene";
    }
}
;
async function getAnamnesisAlert(odontoUrl, patient_id) {
    try {
        const res = await fetch(`${odontoUrl.toString()}patient/alerts/${patient_id}`, {
            credentials: 'include'
        });
        if (!res.ok)
            return;
        const alerts = (await res.json()).result;
        const alertsData = {
            anamnesisAlerts: alerts.anamnesis ? alerts.anamnesis[0] : {},
            vitalSignsAlerts: alerts.vital_signs ? alerts.vital_signs[0] : null,
            referralAlerts: alerts.referral ? alerts.referral[0] : "",
            fileAlerts: alerts.consent_file_count,
            hasDrugs: alerts.habit ? alerts.habit[0]?.drugs : false,
        };
        const vital_signs_alert_info = {
            capillary_blood_glucose_empty_stomach: "Glicemia capilar fuera de rango (en ayunas)",
            capillary_blood_glucose: "Glicemia capilar fuera de rango (sin ayuno)",
            blood_pressure: "Presión sistólica fuera de rango",
            diastolic_blood_pressure: "Presión diastólica fuera de rango",
        };
        const validateVitalSigns = (jsonObj) => {
            const newJsonObj = {};
            if (!(jsonObj["blood_pressure"] >= 90 && jsonObj["blood_pressure"] <= 120)) {
                newJsonObj["blood_pressure"] = jsonObj["blood_pressure"];
            }
            if (!(jsonObj["diastolic_blood_pressure"] >= 60 &&
                jsonObj["diastolic_blood_pressure"] <= 80)) {
                newJsonObj["diastolic_blood_pressure"] =
                    jsonObj["diastolic_blood_pressure"];
            }
            if (!(jsonObj["capillary_blood_glucose"] >= 70 &&
                jsonObj["capillary_blood_glucose"] <= 99 &&
                jsonObj["empty_stomach"])) {
                newJsonObj["capillary_blood_glucose_empty_stomach"] =
                    jsonObj["capillary_blood_glucose"];
            }
            else if (!(jsonObj["capillary_blood_glucose"] <= 140 && !jsonObj["empty_stomach"])) {
                newJsonObj["capillary_blood_glucose"] =
                    jsonObj["capillary_blood_glucose"];
            }
            return newJsonObj;
        };
        return alerts;
    }
    catch (error) {
        return { data: { error: true } };
    }
}
;
export async function initFetch2({ scheduleId, store, urls }) {
    const response = await fetch(`${urls.odonto.toString()}tego-jitsi/schedule/${scheduleId}`, {
        credentials: 'include'
    });
    if (!response.ok)
        throw new Error("Error de fetch");
    const data = (await response.json());
    const alerts = await getAnamnesisAlert(urls.odonto, data.patient.id);
    return data;
}
export function getConferenceName(params) {
    const date = params.start.split("T")[0];
    const names = params.patient.names;
    const lastnames = params.patient.lastnames;
    const name = [names, lastnames].map(str => str.trim()).join(" ");
    return `${name} | ${date}`;
}
export function getFileURL(data, backendURL) {
    return `${backendURL.toString()}${data.file.url}/${data.file.name}`;
}
